import NestedForm from '@stimulus-components/rails-nested-form'

export default NestedForm
